import { FC, useEffect } from 'react'

import { useDispatch } from 'react-redux'

import { addTimeAction } from 'actions/clientStatisticAction'
import { ClientService } from 'api/clientStatisticApi'
import {
  createStartMark,
  endPostfix,
  PerformanceProps,
} from 'components/system/statistic/Perfomance'

export const MeasurerEnd: FC<PerformanceProps> = ({ operation }) => {
  const endMark = operation + endPostfix
  const startMark = createStartMark(operation)
  const dispatch = useDispatch()
  useEffect(() => {
    const startEntry = performance
      .getEntries()
      .find(({ name }) => name === startMark)
    if (startEntry) {
      performance.mark(endMark)
      try {
        // consoleLog({ startEntry })
        performance.measure(operation, startMark, endMark)
        const [measureResult] = performance.getEntriesByName(operation)
        // consoleLog(measureResult)
        dispatch(
          addTimeAction(
            ClientService.WebComponent,
            operation,
            measureResult.startTime,
            measureResult.startTime + measureResult.duration
          )
        )
        performance.clearMarks(startMark)
        performance.clearMarks(endMark)
        performance.clearMeasures(operation)
      } catch (error) {
        console.error(`Measurer end error for operation "${operation}"`, error)
      }
    } else {
      // console.warn(`Measurer start mark not found for "${operation}"`)
    }
  }, [])
  return null
}
